import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { Button, CardSimulate, Loader, Title } from '@components/atoms'
import SearchInput from '@components/atoms/SearchInput'
import { useInputBounce, useQuery } from '@hooks'
import { SimulateType } from '@models/simulated.model'
import { simulatedAPI } from '@services/SimulatedAPI'
import { trackingAPI } from '@services/TrackingAPI'
import { modalCreators } from '@store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@store/hooks'

import { SimulateStyles } from './style'

const { container, titleIndex, ContainerGrid } = SimulateStyles

export const Simulate = () => {
	const query = useQuery()
	const dispatch = useAppDispatch()
	const searchQs = query.get('search') || ''
	const [search, setSearch] = useState(decodeURIComponent(searchQs))
	const [searchQuery, setSearchQuery] = useState(decodeURIComponent(searchQs))
	const [pageReadMode, setPageReadMode] = useState(1)
	const [simulated, setSimulated] = useState<Array<SimulateType>>([])
	const [isMore, setIsMore] = useState(false)
	const {
		premium,
		profile: { id: clientId },
	} = useAppSelector((state) => state)

	const isFree = !premium.value

	const [setTracking] = trackingAPI.useSetTrackingMutation()

	const [getAllSimulated, { data, isSuccess, isLoading }] =
		simulatedAPI.useGetAllSimulatedMutation()

	const searchCallback = useCallback((value: string) => {
		setSearchQuery(value)
	}, [])

	useInputBounce(search, searchCallback)

	const handleMoreSimulated = () => {
		setIsMore(true)
		setPageReadMode((prev) => {
			getAllSimulated({
				page: prev + 1,
				limit: 10,
				search: encodeURIComponent(searchQuery),
			})

			return prev + 1
		})
	}

	useEffect(() => {
		getAllSimulated({
			page: 1,
			limit: 10,
		})
	}, [getAllSimulated])

	useEffect(() => {
		if (search.length > 1) {
			getAllSimulated({
				page: 1,
				limit: 10,
				search: encodeURIComponent(searchQuery),
			})
		} else {
			getAllSimulated({
				page: 1,
				limit: 10,
			})
		}
	}, [getAllSimulated, search.length, searchQuery])

	useEffect(() => {
		if (isSuccess && data && isMore) {
			setSimulated((item) => {
				if (item.length > 0) {
					return [...item, ...data.items]
				}

				return data.items
			})
			setIsMore(false)
		} else if (isSuccess && data) {
			setSimulated(data.items)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess, data])

	useEffect(() => {
		if (isFree) {
			dispatch(
				modalCreators.openModal({
					name: 'freeLimit',
					modalInfo: {
						title: 'Adquira agora o acesso aos nossos simulados!',
						button: {
							label: 'Quero ser Premium',
							icon: 'premium',
							action() {
								setTracking({
									clientId,
									action: 'mockCTA',
								})
							},
						},
					},
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isFree])

	return (
		<div className={container()}>
			<div>
				<div className={titleIndex()}>
					<Title variant='h1' color='$neutral160'>
						Simulados
					</Title>
					<div>
						<SearchInput
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							maxLength={30}
							placeholder='Busque pelo nome'
							css={{ maxWidth: '100%', '@md': { maxWidth: '287px' } }}
						/>
					</div>
				</div>
			</div>

			<div>
				{isLoading ? (
					<Loader />
				) : (
					<ContainerGrid>
						{simulated &&
							simulated.length > 0 &&
							simulated?.map((item, index) => (
								<Link to={`/simulados/${item.id}`} key={index}>
									<CardSimulate
										name={item.name}
										questionNumber={item.questionCount}
										rating={item.rating}
									/>
								</Link>
							))}
					</ContainerGrid>
				)}

				{isSuccess &&
					simulated &&
					simulated.length > 0 &&
					simulated.length >= pageReadMode * 10 && (
						<div style={{ margin: '32px 0 12px' }}>
							<Button onClick={handleMoreSimulated}>Carregar mais</Button>
						</div>
					)}
			</div>
		</div>
	)
}
